export default function ShieldMark(props) {
  return (
    <svg width='32.682' height='40' viewBox='0 0 32.682 40' fill='#152a46' {...props}>
      <path d='M12.681,29.106,27.234,14.553,24.681,12l-12,11.915L8,19.234,5.447,21.787ZM16.34,0l16.34,7.319V18.213A22.552,22.552,0,0,1,28,32.043,20.327,20.327,0,0,1,16.34,40a20.327,20.327,0,0,1-11.66-7.957A22.552,22.552,0,0,1,0,18.213V7.319Z' />
    </svg>
  )
}
